
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { LoaderComponent } from './core/loader/loader.component';
import { LoaderInterceptor } from './core/loaderinterceptor';
import { LoaderService } from './core/loader.service';
import { ServerconfigService } from './core/serverconfig.service';
import { ApplicationContextService } from './application-context.service';
import { GlobalErrorHandlerService } from './core/errors/global-error-handler.service';
import { AppComponent } from './app.component';
import { NotfoundComponent } from './core/notfound/notfound.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import {ConfirmationService, MessageService } from 'primeng/api';
import { AppInjectorModule } from './app-injector.module';
import { AdsComponentsModule } from './common/ads-components.module';
import { TooltipModule } from 'primeng/tooltip';
import { DatePipe } from '@angular/common';
import { NgxSpinnerModule } from "ngx-spinner";
import { OncologyFormComponent } from './oncologyform/oncologyform.component';
import { SubmissionSuccessComponent } from './submissionsuccess/submissionsuccess.component';
import { DialogModule } from 'primeng/dialog';import { DropdownModule } from 'primeng/dropdown';import { InputNumberModule } from 'primeng/inputnumber';import { PasswordModule } from 'primeng/password';import { CalendarModule } from 'primeng/calendar';import { InputMaskModule } from 'primeng/inputmask';import { TableModule } from 'primeng/table';

@NgModule({
  declarations: [
    AppComponent,
	LoaderComponent,
	NotfoundComponent,
        OncologyFormComponent,SubmissionSuccessComponent,
  ],
  imports: [
    AppInjectorModule,
    FormsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,	
    ToastModule,
    TooltipModule,
    AdsComponentsModule,
    // for Core use:
    LoadingBarModule,
    ConfirmDialogModule,
    NgxSpinnerModule,
     DialogModule,DropdownModule,InputNumberModule,PasswordModule,CalendarModule,InputMaskModule,TableModule,
	  ],
  providers: [ ApplicationContextService, LoaderService,ConfirmationService,MessageService, DatePipe,
  	{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide:APP_INITIALIZER,useFactory: (sites:ServerconfigService) => () => sites.loadConfig(),
      deps:[ServerconfigService], multi:true},
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService }
      ],  
  bootstrap: [AppComponent]
})

export class AppModule { }